
<div class="index-head">
    <span>{{coursePopupTitle}}</span>
 </div>
 <div class="padding-index">
     <span>{{coursePopupDescriptionContent}}</span>
 </div>